// source: assistant-webhook.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
goog.exportSymbol('proto.assistant_api.AssistantWebhook', null, global);
goog.exportSymbol('proto.assistant_api.AssistantWebhookLog', null, global);
goog.exportSymbol('proto.assistant_api.CreateAssistantWebhookRequest', null, global);
goog.exportSymbol('proto.assistant_api.DeleteAssistantWebhookRequest', null, global);
goog.exportSymbol('proto.assistant_api.GetAllAssistantWebhookLogRequest', null, global);
goog.exportSymbol('proto.assistant_api.GetAllAssistantWebhookLogResponse', null, global);
goog.exportSymbol('proto.assistant_api.GetAllAssistantWebhookRequest', null, global);
goog.exportSymbol('proto.assistant_api.GetAllAssistantWebhookResponse', null, global);
goog.exportSymbol('proto.assistant_api.GetAssistantWebhookLogRequest', null, global);
goog.exportSymbol('proto.assistant_api.GetAssistantWebhookLogResponse', null, global);
goog.exportSymbol('proto.assistant_api.GetAssistantWebhookRequest', null, global);
goog.exportSymbol('proto.assistant_api.GetAssistantWebhookResponse', null, global);
goog.exportSymbol('proto.assistant_api.UpdateAssistantWebhookRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantWebhook = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.AssistantWebhook.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.AssistantWebhook, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantWebhook.displayName = 'proto.assistant_api.AssistantWebhook';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantWebhookLog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.AssistantWebhookLog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantWebhookLog.displayName = 'proto.assistant_api.AssistantWebhookLog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.CreateAssistantWebhookRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.CreateAssistantWebhookRequest.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.CreateAssistantWebhookRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.CreateAssistantWebhookRequest.displayName = 'proto.assistant_api.CreateAssistantWebhookRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.UpdateAssistantWebhookRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.UpdateAssistantWebhookRequest.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.UpdateAssistantWebhookRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.UpdateAssistantWebhookRequest.displayName = 'proto.assistant_api.UpdateAssistantWebhookRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAssistantWebhookRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.GetAssistantWebhookRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAssistantWebhookRequest.displayName = 'proto.assistant_api.GetAssistantWebhookRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.DeleteAssistantWebhookRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.DeleteAssistantWebhookRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.DeleteAssistantWebhookRequest.displayName = 'proto.assistant_api.DeleteAssistantWebhookRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAssistantWebhookResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.GetAssistantWebhookResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAssistantWebhookResponse.displayName = 'proto.assistant_api.GetAssistantWebhookResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAllAssistantWebhookRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.GetAllAssistantWebhookRequest.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.GetAllAssistantWebhookRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAllAssistantWebhookRequest.displayName = 'proto.assistant_api.GetAllAssistantWebhookRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAllAssistantWebhookResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.GetAllAssistantWebhookResponse.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.GetAllAssistantWebhookResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAllAssistantWebhookResponse.displayName = 'proto.assistant_api.GetAllAssistantWebhookResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.GetAllAssistantWebhookLogRequest.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.GetAllAssistantWebhookLogRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAllAssistantWebhookLogRequest.displayName = 'proto.assistant_api.GetAllAssistantWebhookLogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAssistantWebhookLogRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.GetAssistantWebhookLogRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAssistantWebhookLogRequest.displayName = 'proto.assistant_api.GetAssistantWebhookLogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAssistantWebhookLogResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.GetAssistantWebhookLogResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAssistantWebhookLogResponse.displayName = 'proto.assistant_api.GetAssistantWebhookLogResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.GetAllAssistantWebhookLogResponse.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.GetAllAssistantWebhookLogResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAllAssistantWebhookLogResponse.displayName = 'proto.assistant_api.GetAllAssistantWebhookLogResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.AssistantWebhook.repeatedFields_ = [2,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantWebhook.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantWebhook.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantWebhook} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantWebhook.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistanteventsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    httpmethod: jspb.Message.getFieldWithDefault(msg, 4, ""),
    httpurl: jspb.Message.getFieldWithDefault(msg, 5, ""),
    httpheadersMap: (f = msg.getHttpheadersMap()) ? f.toObject(includeInstance, undefined) : [],
    httpbodyMap: (f = msg.getHttpbodyMap()) ? f.toObject(includeInstance, undefined) : [],
    timeoutsecond: jspb.Message.getFieldWithDefault(msg, 19, 0),
    executionpriority: jspb.Message.getFieldWithDefault(msg, 20, 0),
    retrystatuscodesList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    retrycount: jspb.Message.getFieldWithDefault(msg, 9, 0),
    assistantid: jspb.Message.getFieldWithDefault(msg, 10, "0"),
    status: jspb.Message.getFieldWithDefault(msg, 12, ""),
    createdby: jspb.Message.getFieldWithDefault(msg, 13, "0"),
    createduser: (f = msg.getCreateduser()) && common_pb.User.toObject(includeInstance, f),
    updatedby: jspb.Message.getFieldWithDefault(msg, 15, "0"),
    updateduser: (f = msg.getUpdateduser()) && common_pb.User.toObject(includeInstance, f),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantWebhook}
 */
proto.assistant_api.AssistantWebhook.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantWebhook;
  return proto.assistant_api.AssistantWebhook.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantWebhook} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantWebhook}
 */
proto.assistant_api.AssistantWebhook.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAssistantevents(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHttpmethod(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setHttpurl(value);
      break;
    case 6:
      var value = msg.getHttpheadersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 7:
      var value = msg.getHttpbodyMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 19:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTimeoutsecond(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExecutionpriority(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addRetrystatuscodes(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRetrycount(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setCreatedby(value);
      break;
    case 14:
      var value = new common_pb.User;
      reader.readMessage(value,common_pb.User.deserializeBinaryFromReader);
      msg.setCreateduser(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setUpdatedby(value);
      break;
    case 16:
      var value = new common_pb.User;
      reader.readMessage(value,common_pb.User.deserializeBinaryFromReader);
      msg.setUpdateduser(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 18:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantWebhook.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantWebhook.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantWebhook} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantWebhook.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistanteventsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHttpmethod();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHttpurl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getHttpheadersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getHttpbodyMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getTimeoutsecond();
  if (f !== 0) {
    writer.writeUint32(
      19,
      f
    );
  }
  f = message.getExecutionpriority();
  if (f !== 0) {
    writer.writeUint32(
      20,
      f
    );
  }
  f = message.getRetrystatuscodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getRetrycount();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      10,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCreatedby();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      13,
      f
    );
  }
  f = message.getCreateduser();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      common_pb.User.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedby();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      15,
      f
    );
  }
  f = message.getUpdateduser();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      common_pb.User.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantWebhook.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * repeated string assistantEvents = 2;
 * @return {!Array<string>}
 */
proto.assistant_api.AssistantWebhook.prototype.getAssistanteventsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.setAssistanteventsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.addAssistantevents = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.clearAssistanteventsList = function() {
  return this.setAssistanteventsList([]);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.assistant_api.AssistantWebhook.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string httpMethod = 4;
 * @return {string}
 */
proto.assistant_api.AssistantWebhook.prototype.getHttpmethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.setHttpmethod = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string httpUrl = 5;
 * @return {string}
 */
proto.assistant_api.AssistantWebhook.prototype.getHttpurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.setHttpurl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * map<string, string> httpHeaders = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.assistant_api.AssistantWebhook.prototype.getHttpheadersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.clearHttpheadersMap = function() {
  this.getHttpheadersMap().clear();
  return this;};


/**
 * map<string, string> httpBody = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.assistant_api.AssistantWebhook.prototype.getHttpbodyMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.clearHttpbodyMap = function() {
  this.getHttpbodyMap().clear();
  return this;};


/**
 * optional uint32 timeoutSecond = 19;
 * @return {number}
 */
proto.assistant_api.AssistantWebhook.prototype.getTimeoutsecond = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.setTimeoutsecond = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional uint32 executionPriority = 20;
 * @return {number}
 */
proto.assistant_api.AssistantWebhook.prototype.getExecutionpriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.setExecutionpriority = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * repeated string retryStatusCodes = 8;
 * @return {!Array<string>}
 */
proto.assistant_api.AssistantWebhook.prototype.getRetrystatuscodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.setRetrystatuscodesList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.addRetrystatuscodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.clearRetrystatuscodesList = function() {
  return this.setRetrystatuscodesList([]);
};


/**
 * optional uint32 retryCount = 9;
 * @return {number}
 */
proto.assistant_api.AssistantWebhook.prototype.getRetrycount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.setRetrycount = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional uint64 assistantId = 10;
 * @return {string}
 */
proto.assistant_api.AssistantWebhook.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 10, value);
};


/**
 * optional string status = 12;
 * @return {string}
 */
proto.assistant_api.AssistantWebhook.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional uint64 createdBy = 13;
 * @return {string}
 */
proto.assistant_api.AssistantWebhook.prototype.getCreatedby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.setCreatedby = function(value) {
  return jspb.Message.setProto3StringIntField(this, 13, value);
};


/**
 * optional User createdUser = 14;
 * @return {?proto.User}
 */
proto.assistant_api.AssistantWebhook.prototype.getCreateduser = function() {
  return /** @type{?proto.User} */ (
    jspb.Message.getWrapperField(this, common_pb.User, 14));
};


/**
 * @param {?proto.User|undefined} value
 * @return {!proto.assistant_api.AssistantWebhook} returns this
*/
proto.assistant_api.AssistantWebhook.prototype.setCreateduser = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.clearCreateduser = function() {
  return this.setCreateduser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebhook.prototype.hasCreateduser = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional uint64 updatedBy = 15;
 * @return {string}
 */
proto.assistant_api.AssistantWebhook.prototype.getUpdatedby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.setUpdatedby = function(value) {
  return jspb.Message.setProto3StringIntField(this, 15, value);
};


/**
 * optional User updatedUser = 16;
 * @return {?proto.User}
 */
proto.assistant_api.AssistantWebhook.prototype.getUpdateduser = function() {
  return /** @type{?proto.User} */ (
    jspb.Message.getWrapperField(this, common_pb.User, 16));
};


/**
 * @param {?proto.User|undefined} value
 * @return {!proto.assistant_api.AssistantWebhook} returns this
*/
proto.assistant_api.AssistantWebhook.prototype.setUpdateduser = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.clearUpdateduser = function() {
  return this.setUpdateduser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebhook.prototype.hasUpdateduser = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.Timestamp createdDate = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantWebhook.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantWebhook} returns this
*/
proto.assistant_api.AssistantWebhook.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebhook.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 18;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantWebhook.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 18));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantWebhook} returns this
*/
proto.assistant_api.AssistantWebhook.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebhook} returns this
 */
proto.assistant_api.AssistantWebhook.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebhook.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 18) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantWebhookLog.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantWebhookLog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantWebhookLog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantWebhookLog.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    webhookid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    request: (f = msg.getRequest()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    response: (f = msg.getResponse()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 5, ""),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    assistantid: jspb.Message.getFieldWithDefault(msg, 8, "0"),
    projectid: jspb.Message.getFieldWithDefault(msg, 9, "0"),
    organizationid: jspb.Message.getFieldWithDefault(msg, 10, "0"),
    assistantconversationid: jspb.Message.getFieldWithDefault(msg, 11, "0"),
    assetprefix: jspb.Message.getFieldWithDefault(msg, 12, ""),
    event: jspb.Message.getFieldWithDefault(msg, 13, ""),
    responsestatus: jspb.Message.getFieldWithDefault(msg, 14, "0"),
    timetaken: jspb.Message.getFieldWithDefault(msg, 15, "0"),
    retrycount: jspb.Message.getFieldWithDefault(msg, 16, 0),
    httpmethod: jspb.Message.getFieldWithDefault(msg, 17, ""),
    httpurl: jspb.Message.getFieldWithDefault(msg, 18, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantWebhookLog}
 */
proto.assistant_api.AssistantWebhookLog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantWebhookLog;
  return proto.assistant_api.AssistantWebhookLog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantWebhookLog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantWebhookLog}
 */
proto.assistant_api.AssistantWebhookLog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setWebhookid(value);
      break;
    case 3:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    case 4:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setResponse(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setProjectid(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setOrganizationid(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantconversationid(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetprefix(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvent(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setResponsestatus(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setTimetaken(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRetrycount(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setHttpmethod(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setHttpurl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantWebhookLog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantWebhookLog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantWebhookLog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantWebhookLog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getWebhookid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getResponse();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      8,
      f
    );
  }
  f = message.getProjectid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      9,
      f
    );
  }
  f = message.getOrganizationid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      10,
      f
    );
  }
  f = message.getAssistantconversationid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      11,
      f
    );
  }
  f = message.getAssetprefix();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getEvent();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getResponsestatus();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      14,
      f
    );
  }
  f = message.getTimetaken();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      15,
      f
    );
  }
  f = message.getRetrycount();
  if (f !== 0) {
    writer.writeUint32(
      16,
      f
    );
  }
  f = message.getHttpmethod();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getHttpurl();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 webhookId = 2;
 * @return {string}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getWebhookid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.setWebhookid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional google.protobuf.Struct request = 3;
 * @return {?proto.google.protobuf.Struct}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getRequest = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 3));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
*/
proto.assistant_api.AssistantWebhookLog.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebhookLog.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Struct response = 4;
 * @return {?proto.google.protobuf.Struct}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getResponse = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 4));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
*/
proto.assistant_api.AssistantWebhookLog.prototype.setResponse = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.clearResponse = function() {
  return this.setResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebhookLog.prototype.hasResponse = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp createdDate = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
*/
proto.assistant_api.AssistantWebhookLog.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebhookLog.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
*/
proto.assistant_api.AssistantWebhookLog.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebhookLog.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional uint64 assistantId = 8;
 * @return {string}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 8, value);
};


/**
 * optional uint64 projectId = 9;
 * @return {string}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getProjectid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.setProjectid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 9, value);
};


/**
 * optional uint64 organizationId = 10;
 * @return {string}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getOrganizationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.setOrganizationid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 10, value);
};


/**
 * optional uint64 assistantConversationId = 11;
 * @return {string}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getAssistantconversationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.setAssistantconversationid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 11, value);
};


/**
 * optional string assetPrefix = 12;
 * @return {string}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getAssetprefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.setAssetprefix = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string event = 13;
 * @return {string}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getEvent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.setEvent = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional uint64 responseStatus = 14;
 * @return {string}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getResponsestatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.setResponsestatus = function(value) {
  return jspb.Message.setProto3StringIntField(this, 14, value);
};


/**
 * optional uint64 timeTaken = 15;
 * @return {string}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getTimetaken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.setTimetaken = function(value) {
  return jspb.Message.setProto3StringIntField(this, 15, value);
};


/**
 * optional uint32 retryCount = 16;
 * @return {number}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getRetrycount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.setRetrycount = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional string httpMethod = 17;
 * @return {string}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getHttpmethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.setHttpmethod = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string httpUrl = 18;
 * @return {string}
 */
proto.assistant_api.AssistantWebhookLog.prototype.getHttpurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebhookLog} returns this
 */
proto.assistant_api.AssistantWebhookLog.prototype.setHttpurl = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.CreateAssistantWebhookRequest.repeatedFields_ = [2,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.CreateAssistantWebhookRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.CreateAssistantWebhookRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantWebhookRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistanteventsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    httpmethod: jspb.Message.getFieldWithDefault(msg, 4, ""),
    httpurl: jspb.Message.getFieldWithDefault(msg, 5, ""),
    httpheadersMap: (f = msg.getHttpheadersMap()) ? f.toObject(includeInstance, undefined) : [],
    httpbodyMap: (f = msg.getHttpbodyMap()) ? f.toObject(includeInstance, undefined) : [],
    timeoutsecond: jspb.Message.getFieldWithDefault(msg, 7, 0),
    retrystatuscodesList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    maxretrycount: jspb.Message.getFieldWithDefault(msg, 9, 0),
    assistantid: jspb.Message.getFieldWithDefault(msg, 10, "0"),
    executionpriority: jspb.Message.getFieldWithDefault(msg, 20, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.CreateAssistantWebhookRequest}
 */
proto.assistant_api.CreateAssistantWebhookRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.CreateAssistantWebhookRequest;
  return proto.assistant_api.CreateAssistantWebhookRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.CreateAssistantWebhookRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.CreateAssistantWebhookRequest}
 */
proto.assistant_api.CreateAssistantWebhookRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAssistantevents(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHttpmethod(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setHttpurl(value);
      break;
    case 6:
      var value = msg.getHttpheadersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 11:
      var value = msg.getHttpbodyMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTimeoutsecond(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addRetrystatuscodes(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxretrycount(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExecutionpriority(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.CreateAssistantWebhookRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.CreateAssistantWebhookRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantWebhookRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistanteventsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHttpmethod();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHttpurl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getHttpheadersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getHttpbodyMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(11, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getTimeoutsecond();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getRetrystatuscodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getMaxretrycount();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      10,
      f
    );
  }
  f = message.getExecutionpriority();
  if (f !== 0) {
    writer.writeUint32(
      20,
      f
    );
  }
};


/**
 * repeated string assistantEvents = 2;
 * @return {!Array<string>}
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.getAssistanteventsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.assistant_api.CreateAssistantWebhookRequest} returns this
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.setAssistanteventsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.assistant_api.CreateAssistantWebhookRequest} returns this
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.addAssistantevents = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.CreateAssistantWebhookRequest} returns this
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.clearAssistanteventsList = function() {
  return this.setAssistanteventsList([]);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantWebhookRequest} returns this
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string httpMethod = 4;
 * @return {string}
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.getHttpmethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantWebhookRequest} returns this
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.setHttpmethod = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string httpUrl = 5;
 * @return {string}
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.getHttpurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantWebhookRequest} returns this
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.setHttpurl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * map<string, string> httpHeaders = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.getHttpheadersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.assistant_api.CreateAssistantWebhookRequest} returns this
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.clearHttpheadersMap = function() {
  this.getHttpheadersMap().clear();
  return this;};


/**
 * map<string, string> httpBody = 11;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.getHttpbodyMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 11, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.assistant_api.CreateAssistantWebhookRequest} returns this
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.clearHttpbodyMap = function() {
  this.getHttpbodyMap().clear();
  return this;};


/**
 * optional uint32 timeoutSecond = 7;
 * @return {number}
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.getTimeoutsecond = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.CreateAssistantWebhookRequest} returns this
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.setTimeoutsecond = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * repeated string retryStatusCodes = 8;
 * @return {!Array<string>}
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.getRetrystatuscodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.assistant_api.CreateAssistantWebhookRequest} returns this
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.setRetrystatuscodesList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.assistant_api.CreateAssistantWebhookRequest} returns this
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.addRetrystatuscodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.CreateAssistantWebhookRequest} returns this
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.clearRetrystatuscodesList = function() {
  return this.setRetrystatuscodesList([]);
};


/**
 * optional uint32 maxRetryCount = 9;
 * @return {number}
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.getMaxretrycount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.CreateAssistantWebhookRequest} returns this
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.setMaxretrycount = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional uint64 assistantId = 10;
 * @return {string}
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantWebhookRequest} returns this
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 10, value);
};


/**
 * optional uint32 executionPriority = 20;
 * @return {number}
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.getExecutionpriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.CreateAssistantWebhookRequest} returns this
 */
proto.assistant_api.CreateAssistantWebhookRequest.prototype.setExecutionpriority = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.UpdateAssistantWebhookRequest.repeatedFields_ = [2,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.UpdateAssistantWebhookRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.UpdateAssistantWebhookRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.UpdateAssistantWebhookRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistanteventsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    httpmethod: jspb.Message.getFieldWithDefault(msg, 4, ""),
    httpurl: jspb.Message.getFieldWithDefault(msg, 5, ""),
    httpheadersMap: (f = msg.getHttpheadersMap()) ? f.toObject(includeInstance, undefined) : [],
    httpbodyMap: (f = msg.getHttpbodyMap()) ? f.toObject(includeInstance, undefined) : [],
    timeoutsecond: jspb.Message.getFieldWithDefault(msg, 7, 0),
    retrystatuscodesList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    maxretrycount: jspb.Message.getFieldWithDefault(msg, 9, 0),
    assistantid: jspb.Message.getFieldWithDefault(msg, 10, "0"),
    executionpriority: jspb.Message.getFieldWithDefault(msg, 20, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest}
 */
proto.assistant_api.UpdateAssistantWebhookRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.UpdateAssistantWebhookRequest;
  return proto.assistant_api.UpdateAssistantWebhookRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.UpdateAssistantWebhookRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest}
 */
proto.assistant_api.UpdateAssistantWebhookRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAssistantevents(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHttpmethod(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setHttpurl(value);
      break;
    case 6:
      var value = msg.getHttpheadersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 11:
      var value = msg.getHttpbodyMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTimeoutsecond(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addRetrystatuscodes(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxretrycount(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExecutionpriority(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.UpdateAssistantWebhookRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.UpdateAssistantWebhookRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.UpdateAssistantWebhookRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistanteventsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHttpmethod();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHttpurl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getHttpheadersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getHttpbodyMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(11, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getTimeoutsecond();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getRetrystatuscodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getMaxretrycount();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      10,
      f
    );
  }
  f = message.getExecutionpriority();
  if (f !== 0) {
    writer.writeUint32(
      20,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest} returns this
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * repeated string assistantEvents = 2;
 * @return {!Array<string>}
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.getAssistanteventsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest} returns this
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.setAssistanteventsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest} returns this
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.addAssistantevents = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest} returns this
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.clearAssistanteventsList = function() {
  return this.setAssistanteventsList([]);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest} returns this
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string httpMethod = 4;
 * @return {string}
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.getHttpmethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest} returns this
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.setHttpmethod = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string httpUrl = 5;
 * @return {string}
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.getHttpurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest} returns this
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.setHttpurl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * map<string, string> httpHeaders = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.getHttpheadersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest} returns this
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.clearHttpheadersMap = function() {
  this.getHttpheadersMap().clear();
  return this;};


/**
 * map<string, string> httpBody = 11;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.getHttpbodyMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 11, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest} returns this
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.clearHttpbodyMap = function() {
  this.getHttpbodyMap().clear();
  return this;};


/**
 * optional uint32 timeoutSecond = 7;
 * @return {number}
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.getTimeoutsecond = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest} returns this
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.setTimeoutsecond = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * repeated string retryStatusCodes = 8;
 * @return {!Array<string>}
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.getRetrystatuscodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest} returns this
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.setRetrystatuscodesList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest} returns this
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.addRetrystatuscodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest} returns this
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.clearRetrystatuscodesList = function() {
  return this.setRetrystatuscodesList([]);
};


/**
 * optional uint32 maxRetryCount = 9;
 * @return {number}
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.getMaxretrycount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest} returns this
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.setMaxretrycount = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional uint64 assistantId = 10;
 * @return {string}
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest} returns this
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 10, value);
};


/**
 * optional uint32 executionPriority = 20;
 * @return {number}
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.getExecutionpriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.UpdateAssistantWebhookRequest} returns this
 */
proto.assistant_api.UpdateAssistantWebhookRequest.prototype.setExecutionpriority = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAssistantWebhookRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAssistantWebhookRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAssistantWebhookRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantWebhookRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantid: jspb.Message.getFieldWithDefault(msg, 2, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAssistantWebhookRequest}
 */
proto.assistant_api.GetAssistantWebhookRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAssistantWebhookRequest;
  return proto.assistant_api.GetAssistantWebhookRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAssistantWebhookRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAssistantWebhookRequest}
 */
proto.assistant_api.GetAssistantWebhookRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAssistantWebhookRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAssistantWebhookRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAssistantWebhookRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantWebhookRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.GetAssistantWebhookRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.GetAssistantWebhookRequest} returns this
 */
proto.assistant_api.GetAssistantWebhookRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantId = 2;
 * @return {string}
 */
proto.assistant_api.GetAssistantWebhookRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.GetAssistantWebhookRequest} returns this
 */
proto.assistant_api.GetAssistantWebhookRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.DeleteAssistantWebhookRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.DeleteAssistantWebhookRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.DeleteAssistantWebhookRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.DeleteAssistantWebhookRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantid: jspb.Message.getFieldWithDefault(msg, 2, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.DeleteAssistantWebhookRequest}
 */
proto.assistant_api.DeleteAssistantWebhookRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.DeleteAssistantWebhookRequest;
  return proto.assistant_api.DeleteAssistantWebhookRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.DeleteAssistantWebhookRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.DeleteAssistantWebhookRequest}
 */
proto.assistant_api.DeleteAssistantWebhookRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.DeleteAssistantWebhookRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.DeleteAssistantWebhookRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.DeleteAssistantWebhookRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.DeleteAssistantWebhookRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.DeleteAssistantWebhookRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.DeleteAssistantWebhookRequest} returns this
 */
proto.assistant_api.DeleteAssistantWebhookRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantId = 2;
 * @return {string}
 */
proto.assistant_api.DeleteAssistantWebhookRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.DeleteAssistantWebhookRequest} returns this
 */
proto.assistant_api.DeleteAssistantWebhookRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAssistantWebhookResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAssistantWebhookResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAssistantWebhookResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantWebhookResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.assistant_api.AssistantWebhook.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAssistantWebhookResponse}
 */
proto.assistant_api.GetAssistantWebhookResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAssistantWebhookResponse;
  return proto.assistant_api.GetAssistantWebhookResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAssistantWebhookResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAssistantWebhookResponse}
 */
proto.assistant_api.GetAssistantWebhookResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.assistant_api.AssistantWebhook;
      reader.readMessage(value,proto.assistant_api.AssistantWebhook.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAssistantWebhookResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAssistantWebhookResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAssistantWebhookResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantWebhookResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.assistant_api.AssistantWebhook.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.GetAssistantWebhookResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.GetAssistantWebhookResponse} returns this
 */
proto.assistant_api.GetAssistantWebhookResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.GetAssistantWebhookResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.GetAssistantWebhookResponse} returns this
 */
proto.assistant_api.GetAssistantWebhookResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional AssistantWebhook data = 3;
 * @return {?proto.assistant_api.AssistantWebhook}
 */
proto.assistant_api.GetAssistantWebhookResponse.prototype.getData = function() {
  return /** @type{?proto.assistant_api.AssistantWebhook} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantWebhook, 3));
};


/**
 * @param {?proto.assistant_api.AssistantWebhook|undefined} value
 * @return {!proto.assistant_api.GetAssistantWebhookResponse} returns this
*/
proto.assistant_api.GetAssistantWebhookResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantWebhookResponse} returns this
 */
proto.assistant_api.GetAssistantWebhookResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantWebhookResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.GetAssistantWebhookResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.GetAssistantWebhookResponse} returns this
*/
proto.assistant_api.GetAssistantWebhookResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantWebhookResponse} returns this
 */
proto.assistant_api.GetAssistantWebhookResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantWebhookResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.GetAllAssistantWebhookRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAllAssistantWebhookRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAllAssistantWebhookRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAllAssistantWebhookRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantWebhookRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    webhookid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    paginate: (f = msg.getPaginate()) && common_pb.Paginate.toObject(includeInstance, f),
    criteriasList: jspb.Message.toObjectList(msg.getCriteriasList(),
    common_pb.Criteria.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAllAssistantWebhookRequest}
 */
proto.assistant_api.GetAllAssistantWebhookRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAllAssistantWebhookRequest;
  return proto.assistant_api.GetAllAssistantWebhookRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAllAssistantWebhookRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAllAssistantWebhookRequest}
 */
proto.assistant_api.GetAllAssistantWebhookRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setWebhookid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 2:
      var value = new common_pb.Paginate;
      reader.readMessage(value,common_pb.Paginate.deserializeBinaryFromReader);
      msg.setPaginate(value);
      break;
    case 3:
      var value = new common_pb.Criteria;
      reader.readMessage(value,common_pb.Criteria.deserializeBinaryFromReader);
      msg.addCriterias(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAllAssistantWebhookRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAllAssistantWebhookRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAllAssistantWebhookRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantWebhookRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWebhookid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      4,
      f
    );
  }
  f = message.getPaginate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.Paginate.serializeBinaryToWriter
    );
  }
  f = message.getCriteriasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_pb.Criteria.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 webhookId = 1;
 * @return {string}
 */
proto.assistant_api.GetAllAssistantWebhookRequest.prototype.getWebhookid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookRequest} returns this
 */
proto.assistant_api.GetAllAssistantWebhookRequest.prototype.setWebhookid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantId = 4;
 * @return {string}
 */
proto.assistant_api.GetAllAssistantWebhookRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookRequest} returns this
 */
proto.assistant_api.GetAllAssistantWebhookRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional Paginate paginate = 2;
 * @return {?proto.Paginate}
 */
proto.assistant_api.GetAllAssistantWebhookRequest.prototype.getPaginate = function() {
  return /** @type{?proto.Paginate} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginate, 2));
};


/**
 * @param {?proto.Paginate|undefined} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookRequest} returns this
*/
proto.assistant_api.GetAllAssistantWebhookRequest.prototype.setPaginate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAllAssistantWebhookRequest} returns this
 */
proto.assistant_api.GetAllAssistantWebhookRequest.prototype.clearPaginate = function() {
  return this.setPaginate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantWebhookRequest.prototype.hasPaginate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated Criteria criterias = 3;
 * @return {!Array<!proto.Criteria>}
 */
proto.assistant_api.GetAllAssistantWebhookRequest.prototype.getCriteriasList = function() {
  return /** @type{!Array<!proto.Criteria>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Criteria, 3));
};


/**
 * @param {!Array<!proto.Criteria>} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookRequest} returns this
*/
proto.assistant_api.GetAllAssistantWebhookRequest.prototype.setCriteriasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Criteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Criteria}
 */
proto.assistant_api.GetAllAssistantWebhookRequest.prototype.addCriterias = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Criteria, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.GetAllAssistantWebhookRequest} returns this
 */
proto.assistant_api.GetAllAssistantWebhookRequest.prototype.clearCriteriasList = function() {
  return this.setCriteriasList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.GetAllAssistantWebhookResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAllAssistantWebhookResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAllAssistantWebhookResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantWebhookResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.assistant_api.AssistantWebhook.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f),
    paginated: (f = msg.getPaginated()) && common_pb.Paginated.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAllAssistantWebhookResponse}
 */
proto.assistant_api.GetAllAssistantWebhookResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAllAssistantWebhookResponse;
  return proto.assistant_api.GetAllAssistantWebhookResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAllAssistantWebhookResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAllAssistantWebhookResponse}
 */
proto.assistant_api.GetAllAssistantWebhookResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.assistant_api.AssistantWebhook;
      reader.readMessage(value,proto.assistant_api.AssistantWebhook.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 5:
      var value = new common_pb.Paginated;
      reader.readMessage(value,common_pb.Paginated.deserializeBinaryFromReader);
      msg.setPaginated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAllAssistantWebhookResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAllAssistantWebhookResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantWebhookResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.assistant_api.AssistantWebhook.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getPaginated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Paginated.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookResponse} returns this
 */
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookResponse} returns this
 */
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated AssistantWebhook data = 3;
 * @return {!Array<!proto.assistant_api.AssistantWebhook>}
 */
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.assistant_api.AssistantWebhook>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.assistant_api.AssistantWebhook, 3));
};


/**
 * @param {!Array<!proto.assistant_api.AssistantWebhook>} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookResponse} returns this
*/
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.assistant_api.AssistantWebhook=} opt_value
 * @param {number=} opt_index
 * @return {!proto.assistant_api.AssistantWebhook}
 */
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.assistant_api.AssistantWebhook, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.GetAllAssistantWebhookResponse} returns this
 */
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookResponse} returns this
*/
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAllAssistantWebhookResponse} returns this
 */
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Paginated paginated = 5;
 * @return {?proto.Paginated}
 */
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.getPaginated = function() {
  return /** @type{?proto.Paginated} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginated, 5));
};


/**
 * @param {?proto.Paginated|undefined} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookResponse} returns this
*/
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.setPaginated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAllAssistantWebhookResponse} returns this
 */
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.clearPaginated = function() {
  return this.setPaginated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantWebhookResponse.prototype.hasPaginated = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAllAssistantWebhookLogRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAllAssistantWebhookLogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    paginate: (f = msg.getPaginate()) && common_pb.Paginate.toObject(includeInstance, f),
    criteriasList: jspb.Message.toObjectList(msg.getCriteriasList(),
    common_pb.Criteria.toObject, includeInstance),
    order: (f = msg.getOrder()) && common_pb.Ordering.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogRequest}
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAllAssistantWebhookLogRequest;
  return proto.assistant_api.GetAllAssistantWebhookLogRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAllAssistantWebhookLogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogRequest}
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setProjectid(value);
      break;
    case 3:
      var value = new common_pb.Paginate;
      reader.readMessage(value,common_pb.Paginate.deserializeBinaryFromReader);
      msg.setPaginate(value);
      break;
    case 4:
      var value = new common_pb.Criteria;
      reader.readMessage(value,common_pb.Criteria.deserializeBinaryFromReader);
      msg.addCriterias(value);
      break;
    case 5:
      var value = new common_pb.Ordering;
      reader.readMessage(value,common_pb.Ordering.deserializeBinaryFromReader);
      msg.setOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAllAssistantWebhookLogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAllAssistantWebhookLogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getPaginate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_pb.Paginate.serializeBinaryToWriter
    );
  }
  f = message.getCriteriasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      common_pb.Criteria.serializeBinaryToWriter
    );
  }
  f = message.getOrder();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Ordering.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 projectId = 2;
 * @return {string}
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.prototype.getProjectid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogRequest} returns this
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.prototype.setProjectid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional Paginate paginate = 3;
 * @return {?proto.Paginate}
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.prototype.getPaginate = function() {
  return /** @type{?proto.Paginate} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginate, 3));
};


/**
 * @param {?proto.Paginate|undefined} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogRequest} returns this
*/
proto.assistant_api.GetAllAssistantWebhookLogRequest.prototype.setPaginate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogRequest} returns this
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.prototype.clearPaginate = function() {
  return this.setPaginate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.prototype.hasPaginate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated Criteria criterias = 4;
 * @return {!Array<!proto.Criteria>}
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.prototype.getCriteriasList = function() {
  return /** @type{!Array<!proto.Criteria>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Criteria, 4));
};


/**
 * @param {!Array<!proto.Criteria>} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogRequest} returns this
*/
proto.assistant_api.GetAllAssistantWebhookLogRequest.prototype.setCriteriasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Criteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Criteria}
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.prototype.addCriterias = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Criteria, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogRequest} returns this
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.prototype.clearCriteriasList = function() {
  return this.setCriteriasList([]);
};


/**
 * optional Ordering order = 5;
 * @return {?proto.Ordering}
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.prototype.getOrder = function() {
  return /** @type{?proto.Ordering} */ (
    jspb.Message.getWrapperField(this, common_pb.Ordering, 5));
};


/**
 * @param {?proto.Ordering|undefined} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogRequest} returns this
*/
proto.assistant_api.GetAllAssistantWebhookLogRequest.prototype.setOrder = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogRequest} returns this
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.prototype.clearOrder = function() {
  return this.setOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantWebhookLogRequest.prototype.hasOrder = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAssistantWebhookLogRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAssistantWebhookLogRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAssistantWebhookLogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantWebhookLogRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    id: jspb.Message.getFieldWithDefault(msg, 3, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAssistantWebhookLogRequest}
 */
proto.assistant_api.GetAssistantWebhookLogRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAssistantWebhookLogRequest;
  return proto.assistant_api.GetAssistantWebhookLogRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAssistantWebhookLogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAssistantWebhookLogRequest}
 */
proto.assistant_api.GetAssistantWebhookLogRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setProjectid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAssistantWebhookLogRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAssistantWebhookLogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAssistantWebhookLogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantWebhookLogRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      3,
      f
    );
  }
};


/**
 * optional uint64 projectId = 2;
 * @return {string}
 */
proto.assistant_api.GetAssistantWebhookLogRequest.prototype.getProjectid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.GetAssistantWebhookLogRequest} returns this
 */
proto.assistant_api.GetAssistantWebhookLogRequest.prototype.setProjectid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional uint64 id = 3;
 * @return {string}
 */
proto.assistant_api.GetAssistantWebhookLogRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.GetAssistantWebhookLogRequest} returns this
 */
proto.assistant_api.GetAssistantWebhookLogRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAssistantWebhookLogResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAssistantWebhookLogResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAssistantWebhookLogResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantWebhookLogResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.assistant_api.AssistantWebhookLog.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAssistantWebhookLogResponse}
 */
proto.assistant_api.GetAssistantWebhookLogResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAssistantWebhookLogResponse;
  return proto.assistant_api.GetAssistantWebhookLogResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAssistantWebhookLogResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAssistantWebhookLogResponse}
 */
proto.assistant_api.GetAssistantWebhookLogResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.assistant_api.AssistantWebhookLog;
      reader.readMessage(value,proto.assistant_api.AssistantWebhookLog.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAssistantWebhookLogResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAssistantWebhookLogResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAssistantWebhookLogResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantWebhookLogResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.assistant_api.AssistantWebhookLog.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.GetAssistantWebhookLogResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.GetAssistantWebhookLogResponse} returns this
 */
proto.assistant_api.GetAssistantWebhookLogResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.GetAssistantWebhookLogResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.GetAssistantWebhookLogResponse} returns this
 */
proto.assistant_api.GetAssistantWebhookLogResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional AssistantWebhookLog data = 3;
 * @return {?proto.assistant_api.AssistantWebhookLog}
 */
proto.assistant_api.GetAssistantWebhookLogResponse.prototype.getData = function() {
  return /** @type{?proto.assistant_api.AssistantWebhookLog} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantWebhookLog, 3));
};


/**
 * @param {?proto.assistant_api.AssistantWebhookLog|undefined} value
 * @return {!proto.assistant_api.GetAssistantWebhookLogResponse} returns this
*/
proto.assistant_api.GetAssistantWebhookLogResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantWebhookLogResponse} returns this
 */
proto.assistant_api.GetAssistantWebhookLogResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantWebhookLogResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.GetAssistantWebhookLogResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.GetAssistantWebhookLogResponse} returns this
*/
proto.assistant_api.GetAssistantWebhookLogResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantWebhookLogResponse} returns this
 */
proto.assistant_api.GetAssistantWebhookLogResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantWebhookLogResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAllAssistantWebhookLogResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAllAssistantWebhookLogResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.assistant_api.AssistantWebhookLog.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f),
    paginated: (f = msg.getPaginated()) && common_pb.Paginated.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogResponse}
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAllAssistantWebhookLogResponse;
  return proto.assistant_api.GetAllAssistantWebhookLogResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAllAssistantWebhookLogResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogResponse}
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.assistant_api.AssistantWebhookLog;
      reader.readMessage(value,proto.assistant_api.AssistantWebhookLog.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 5:
      var value = new common_pb.Paginated;
      reader.readMessage(value,common_pb.Paginated.deserializeBinaryFromReader);
      msg.setPaginated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAllAssistantWebhookLogResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAllAssistantWebhookLogResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.assistant_api.AssistantWebhookLog.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getPaginated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Paginated.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogResponse} returns this
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogResponse} returns this
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated AssistantWebhookLog data = 3;
 * @return {!Array<!proto.assistant_api.AssistantWebhookLog>}
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.assistant_api.AssistantWebhookLog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.assistant_api.AssistantWebhookLog, 3));
};


/**
 * @param {!Array<!proto.assistant_api.AssistantWebhookLog>} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogResponse} returns this
*/
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.assistant_api.AssistantWebhookLog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.assistant_api.AssistantWebhookLog}
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.assistant_api.AssistantWebhookLog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogResponse} returns this
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogResponse} returns this
*/
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogResponse} returns this
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Paginated paginated = 5;
 * @return {?proto.Paginated}
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.getPaginated = function() {
  return /** @type{?proto.Paginated} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginated, 5));
};


/**
 * @param {?proto.Paginated|undefined} value
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogResponse} returns this
*/
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.setPaginated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAllAssistantWebhookLogResponse} returns this
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.clearPaginated = function() {
  return this.setPaginated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantWebhookLogResponse.prototype.hasPaginated = function() {
  return jspb.Message.getField(this, 5) != null;
};


goog.object.extend(exports, proto.assistant_api);
